<template>

  <!--单项选择器弹窗-->
  <div class="alert-box curr">
    <div class="mask question-alert curr" @click="closeFun()"></div>
    <div class="picker-alert-con border-box curr">
      <van-picker show-toolbar :title="pickertitle" :columns="columns"  @cancel="onCancel" @confirm="onConfirm" @change="onChange" />
    </div>
  </div>



</template>

<script>

  import { mapState, mapMutations } from 'vuex'

  import {setStore, getStore, removeStore, getWeekname} from '@/config/mUtils'

  import wxConfirm from '@/wechat-messagebox/Confirm'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D);

  import { Picker } from 'vant';
  import 'vant/lib/index.css';
  Vue.use(Picker);

  export default {
    data(){
      return{
        pickerTxt: '', //所选择的城市名称
        pickerid: '', //所选择城市的id
        columns: []
      }
    },
    props: ['pickerData','pickertitle'],
    created() {
      this.initData();
    },
    methods: {
      //改造数据
      initData:function(){
        var pickerData = this.pickerData;

        if(pickerData.length>0){
          var columns = [];
          for(var i=0; i<pickerData.length; i++){
            var item = pickerData[i];
            //{{item.time}} {{getWeekname(item.time)}} {{item.state==0?'不接待':''}}
            var txt = '';
            if(this.pickertitle=='参观日期'){
              txt = item.time + ' ' + getWeekname(item.time) + (item.state==0?' 闭馆(节假日除外)':'');
            }else if(this.pickertitle=='参观时段'){
              txt = item.time + '（余' + item.num + '）';
            }

            columns.push(txt);
          }
          this.columns = columns;
        }

      },

      //关闭弹窗
      closeFun:function(){
        var sendObj = {};
        sendObj.pickerShow = 0;
        this.$emit('sendObj',sendObj);
      },

      //取消选择
      onCancel: function(){
        this.closeFun();
      },

      //确认选择
      onConfirm: function(value, index){
        console.log(value, index);
        this.pickerTxt = value;
        this.pickerid = this.pickerData[index].id;

        var sendObj = this.pickerData[index];
        sendObj.txt = value;

        sendObj.pickerShow = 0;
        this.$emit('sendObj',sendObj);
      },

      onChange(picker, values, index) {

      },
    },
    components: {

    },

  }

</script>


<style scoped>
  .alert-box{z-index:1001;}
  .question-alert{position:fixed;display:none;opacity:0;animation: opacity0 ease-out .2s;animation-fill-mode: forwards;}
  .question-alert.curr{display:block;animation: opacity1 ease-out .2s;animation-fill-mode: forwards;}

  .picker-alert-con{position: absolute;bottom:0;left: 0;right: 0;height:5rem;background: #fff;animation: down ease-out .2s;animation-fill-mode: forwards;}
  .picker-alert-con.curr{animation: up ease-in .2s;animation-fill-mode: forwards;}
  @keyframes up{from{bottom:-5rem;opacity: 0;}to{bottom:0;opacity: 1;}}
  @keyframes down{from{bottom: 0;opacity: 1;}to{bottom: -5rem;opacity: 0;}}
  @keyframes opacity0{from{opacity: 1;}to{opacity: 0;}}
  @keyframes opacity1{from{opacity: 0;}to{opacity: 1;}}
</style>



// WEBPACK FOOTER //
// src/components/Picker.vue